export default __webpack_public_path__ + "static/media/MapPoint.e982b271.svg";